import React from 'react';
import DailiesTrendChart from './DailiesTrendChart';
import LanguageProgressWidget from './LanguageProgressWidget';
import TaskSection from './TaskSection';
import BurndownChart from './BurndownChart';

interface SystemWidgetRendererProps {
  systemKey: string;
  daysCount: number;
}

const SystemWidgetRenderer: React.FC<SystemWidgetRendererProps> = ({ systemKey, daysCount }) => {
  switch (systemKey) {
    case 'DAILIES_TREND':
      return <DailiesTrendChart daysCount={daysCount} />;
    case 'LANGUAGE_PROGRESS':
      return <LanguageProgressWidget daysCount={daysCount} />;
    case 'TASKS':
      return <TaskSection />;
    case 'BURNDOWN':
      return <BurndownChart />;
    default:
      return null;
  }
};

export default SystemWidgetRenderer;
